<template>
  <v-card>
    <v-progress-linear
        v-if="loading"
        color="#1f7087"
        indeterminate
        rounded
        height="2"
    ></v-progress-linear>

    <v-card-subtitle style="font-size: 18px;">Statistics</v-card-subtitle>

    <v-row class="mx-auto">
      <v-col
          style="margin:0; padding:0; overflow-x:hidden; white-space: nowrap;"
          cols="6"
          v-for="(statList, index) in analyticsDataSet"
          :key="index"
          lg="2"
          sm="6"
          md="4"
      >
        <v-card-title class="d-inline-flex pa-2">
          <v-avatar size="35" color="#eeecfe">
            <v-icon size="22" :color="statList.color">
              {{statList.icon}}
            </v-icon>
          </v-avatar>
          <span>
            <v-card-title style="color: #726c84;">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span style="cursor: pointer;" v-bind="attrs" v-on="on">
                    {{displayTotal(statList)}}
                  </span>
                </template>
                <span>{{tooltipTotal(statList)}}</span>
              </v-tooltip>
            </v-card-title>
            <v-card-subtitle>
              <router-link class="text-decoration-none" style="color: #726c84;" :to="{name: statList.name}">
                {{statList.title}}
              </router-link>
            </v-card-subtitle>
          </span>
        </v-card-title>
      </v-col>
    </v-row>

    <v-card-subtitle v-if="previous" style="color: #726c84;">
      Previous period: outgoing {{formatCount(previous.outgoing)}},
      incoming {{formatCount(previous.incoming)}},
      delivered {{formatCount(previous.delivered)}},
      failed {{formatCount(previous.failed)}}
    </v-card-subtitle>
  </v-card>
</template>

<script>
export default {
  name: "HomeAnalytics",
  props: {
    report: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    metrics() {
      return this.report.metrics || {};
    },
    previous() {
      return this.report.previous || null;
    },
    analyticsDataSet() {
      const metrics = this.metrics;
      return [
        { color: "#0072a7", icon: "mdi-send", title: "Outgoing", total: metrics.outgoing || 0, name: "message-logs" },
        { color: "#00a8a8", icon: "mdi-message-reply-text", title: "Incoming", total: metrics.incoming || 0, name: "message-logs" },
        { color: "green", icon: "mdi-check-circle-outline", title: "Delivered", total: metrics.delivered || 0, name: "message-logs" },
        { color: "red", icon: "mdi-close-circle-outline", title: "Failed", total: metrics.failed || 0, name: "message-logs" },
        { color: "#9600bc", icon: "mdi-clock-outline", title: "Pending", total: metrics.pending || 0, name: "message-logs" },
        { color: "#726c84", icon: "mdi-progress-clock", title: "Processing", total: metrics.processing || 0, name: "message-logs" },
        { color: "#0072a7", icon: "mdi-script", title: "Sent", total: metrics.sent || 0, name: "message-logs" },
        { color: "#00a8a8", icon: "mdi-inbox", title: "Received", total: metrics.received || 0, name: "message-logs" },
        { color: "#00a8a8", icon: "mdi-account-multiple", title: "Contacts", total: metrics.contacts || 0, name: "new-contact" },
        { color: "#00a8a8", icon: "mdi-account-group", title: "Groups", total: metrics.groups || 0, name: "group" },
        { color: "#9600bc", icon: "mdi-account-group-outline", title: "Group sends", total: metrics.group_sends || 0, name: "group-message-logs" },
        { color: "#0072a7", icon: "mdi-message-text", title: "Direct sends", total: metrics.direct_sends || 0, name: "message-logs" },
        { color: "#0072a7", icon: "mdi-cellphone", title: "Devices", total: metrics.devices || 0, name: "pair-phone" },
        { color: "green", icon: "mdi-access-point", title: "Online", total: metrics.online_devices || 0, name: "pair-phone" },
      ];
    },
  },
  methods: {
    displayTotal(stat) {
      return this.abbreviateNumber(Number(stat.total) || 0);
    },
    tooltipTotal(stat) {
      return (Number(stat.total) || 0).toLocaleString();
    },
    formatCount(value) {
      return (Number(value) || 0).toLocaleString();
    },
  },
};
</script>
